var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    transform: "translate(16 18.5)",
    d: "M0 0L2 0L2 8L0 8L0 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    transform: "translate(19 18.5)",
    d: "M5.4204988 0.025175177C5.3254094 0.013975396 5.2243762 0.0083755059 5.1233258 0.0027756162C3.6790459 -0.053239901 2.8647878 0.75321072 2.5795012 1.1004372C2.5022409 1.1956352 2.4665644 1.2516341 2.4665644 1.2516341L2.4665644 0.21558805L0 0.21558805L0 7.9664006L2.4665644 7.9664006L2.5795012 7.9664006C2.5795012 7.1767497 2.5795012 6.3927155 2.5795012 5.6030645C2.5795012 5.1774559 2.5795012 4.7518311 2.5795012 4.3262062C2.5795012 3.7997668 2.5378995 3.2397447 2.8172429 2.7581208C3.0549848 2.3548956 3.4829059 2.1532829 3.9643326 2.1532829C5.3907833 2.1532829 5.4204988 3.3685586 5.4204988 3.4805565C5.4204988 3.4861565 5.4204988 3.4917562 5.4204988 3.4917562L5.4204988 8L8 8L8 2.9429338C8 1.2124349 7.0668621 0.19318849 5.4204988 0.025175177Z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    transform: "translate(16 15)",
    d: "M1 2C1.552281 2 2 1.5522901 2 1C2 0.44771695 1.552281 0 1 0C0.44771194 0 0 0.44771695 0 1C0 1.5522901 0.44771194 2 1 2Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/ln.7ef7bfb99d1753419adec122b7ec3c0e.svg";
export { ForwardRef as ReactComponent };